export { default } from "./Absolute";
export * from "./Absolute";
